import type { FieldErrors } from "react-hook-form";

import { cn, Typography } from "@eisox/design-system";
import { BinIcon } from "@eisox/icons";

import { Tooltip } from "~/components/tooltip";
import { m } from "~/paraglide/messages";

import type { Group as GroupType } from "../helpers";

interface GroupProps {
  name: string;
  onClick: VoidFunction;
  onDelete: VoidFunction;
  selected?: boolean;
  errors?: FieldErrors<GroupType>;
}

export const Group: React.FC<GroupProps> = ({ name, onClick, onDelete, selected = false, errors }) => {
  const handleClickBin = (e: React.MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    onDelete();
  };

  const isOnError = !!errors?.name || !!errors?.items;
  const errorMessage =
    errors &&
    Object.keys(errors)
      .filter(key => !!errors[key as keyof FieldErrors<GroupType>]?.message)
      .map(key => errors[key as keyof FieldErrors<GroupType>]?.message)
      .join("\n");

  return (
    <div
      className={cn(
        "font-normal mb-[5px] flex w-full items-center justify-between rounded-[10px] p-[10px] text-base leading-[24px] text-primary-dark-blue hover:cursor-pointer hover:bg-primary-gray",
        selected && "bg-primary-gray text-primary-blue",
        name === "" && "text-primary-dark-gray italic",
        isOnError && "border border-primary-red",
      )}
      onClick={() => onClick()}
    >
      <Typography>{name !== "" ? name : m.group_name()}</Typography>
      <span className="flex items-center">
        <BinIcon className="ml-[10px]" onClick={handleClickBin} />
        {errors && (
          <Tooltip content={errorMessage} keepHoverOpen={false}>
            <div className="ml-[10px] h-[10px] w-[10px] rounded-full bg-primary-red" />
          </Tooltip>
        )}
      </span>
    </div>
  );
};
